/** Current-vs-Custom pair shared by the Special Pricing card (CONF-106) and
 *  the System Attributes cards (CONF-212). Morganite marks the Custom side,
 *  not a delta: the whole column is the custom figure whether or not this
 *  particular metric moved. */
import React from 'react';

export function ValuePair({ current, custom }) {
  return (
    <div className="flex flex-wrap gap-x-8 gap-y-1">
      <div>
        <p className="text-xs uppercase tracking-wide text-gray-400">Current</p>
        <p className="metric-value">{current}</p>
      </div>
      <div>
        <p className="text-xs uppercase tracking-wide text-morganite">Custom</p>
        <p className="metric-value text-morganite">{custom}</p>
      </div>
    </div>
  );
}

/** Renders `custom` alone unless `metricKey` is one the exec's overrides
 *  touched, in which case Current (computed) sits beside Custom (displayed). */
export function MetricValue({ metricKey, affectedKeys, current, custom }) {
  if (!affectedKeys || !affectedKeys.has(metricKey)) return <p className="metric-value">{custom}</p>;
  return <ValuePair current={current} custom={custom} />;
}

export default ValuePair;
